import React, { Fragment } from 'react';

const Suspend = props => {
  return <Fragment>{props.isLoading ? props.fallback : props.children}</Fragment>;
};

export default Suspend;
